module.exports = __webpack_public_path__ + "img/sp-icon-border.f8fcbfa3.svg";